<template>
  <div class="parent">
    <RouterLink :to="{name: routeNameToRedirect}" >
      <button class="box-button-go-back"><i class="el-icon-back" @click="handleClick"></i></button>
    </RouterLink>
      <div v-if="content" class="content-button-go-back">{{content}}</div>
  </div>
</template>

<script>
export default {
  name: 'BackButton',
  props: {
    routeNameToRedirect: {
      type: String,
      required: true
    },
    content: {
      type: String,
      default: ''
    },
    onButtonClick: {
      type: Function,
      default: null // C'est ici que la méthode de clic est facultative
    }
  },
  methods: {
    handleClick () {
      if (this.onButtonClick) {
        this.onButtonClick()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.parent{
  position: fixed;
  top: 190px;
  left: 360px;
  width: 50px;
  height: 50px;
  background-color: white;
  color: #0AB1BF;
  border-radius:50%;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  .box-button-go-back {
    outline: none;
    position: absolute;
    top:55%;
    left: 49%;
    transform: translate(-50%, -50%);
    color: #0AB1BF;
    i {
      font-size: 1.8em;
      font-weight: 700;
    }
    &:hover{
      opacity: .5;
    }
  }
  &:hover{
    border: 1px solid #0AB1BF;
  }
  .content-button-go-back {
    width: 200px;
    position: absolute;
    left: 54px;
    top: 30%;
  }
}
</style>
